import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import LinkButton from '../../UniformComponents/LinkButton'
import Select from '../form/Select'
import Checkbox from '../form/Checkbox'
import DataTable from '../DataTable'
import SurveyStore from './SurveyStore'
import Badge from '../../UniformComponents/Badge'
import { getUserLink } from '../../utils/helpers'
import Anchor from '../../UniformComponents/Anchor'
import Tooltip from '../../UniformComponents/Tooltip'
import SearchLayout from '../Layouts/Search'

import './survey.scss'

@observer
class MaxbiSearch extends Component {
    constructor(props) {
        super(props)
        this.surveyStore = new SurveyStore(props.store)
        this.setColumns()
    }

    componentDidMount() {
        const { store } = this.props

        store.breadcrumps = [
            {
                name: 'maxbi',
                url: '/maxbi',
                title: 'Maxbi',
            },
        ]
        this.surveyStore.isMaxbi = true
        this.surveyStore.getSurveys()
    }

    getBadge = (status) => {
        const type = {
            completed: 'blue',
            inprogress: 'purple',
            incomplete: 'grey',
            archived: 'yellow',
        }

        const label = {
            completed: 'maxbiSearch.complete',
            inprogress: 'maxbiSearch.status_2',
            incomplete: 'maxbiSearch.status_3',
            archived: 'maxbiSearch.status_4',
        }

        return (
            <Badge
                type={type[status]}
                label={i18n.t(label[status])}
                cssClass="rounded status-badge"
            />
        )
    }

    setColumns = () => {
        const { store } = this.props
        this.columns = [
            {
                name: i18n.t('product'),
                key: 'productName',
                cellClass: 'bold',
            },
            {
                name: i18n.t('year'),
                key: 'year',
            },
            {
                name: i18n.t('status'),
                key: 'status',
                dataTransform: this.getBadge,
            },
            {
                name: 'Required action',
                key: 'status',
                cellClass: 'center',
                dataTransform: (status, { publicId, surveyUserId }) => {
                    if (!['inprogress', 'incomplete'].includes(status)) return null

                    return (
                        <LinkButton
                            target="_blank"
                            cssClass={`action-btn ${status}`}
                            href={
                                getUserLink(
                                    publicId, surveyUserId, true,
                                )
                            }
                            onClick={(e) => {
                                e.stopPropagation()
                            }}
                            label={i18n.t('maxbiSearch.complete')}
                            isExternal
                        >
                            <i className="fa-sharp fa-regular fa-arrow-right" />
                        </LinkButton>
                    )
                },
            },
            {
                name: '',
                key: 'surveyId',
                cellClass: 'center overflow',
                dataTransform: (surveyId, { productId }) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={(e) => e.stopPropagation()}
                            href={`/survey/${surveyId}/company/dashboard/?productId=${productId}`}
                        >
                            <Tooltip
                                text={i18n.t('product_dash')}
                                direction="left"
                            />
                            <i className="fa-light fa-gauge-simple-max" />
                        </Anchor>
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={(e) => e.stopPropagation()}
                            href={`/survey/${surveyId}/report`}
                        >
                            <Tooltip
                                text={i18n.t('home.table.surveyBtn.viewReport')}
                                direction="left"
                            />
                            <i className="fa-light fa-chart-column" />
                        </Anchor>
                    </div>
                ),
            },
        ]
    }

    renderGuide = () => null

    renderTablePanel = () => {
        const { surveyStore } = this

        return (
            <DataTable
                store={surveyStore}
                dataSet={surveyStore.filteredList || []}
                columns={this.columns}
                inMemory
                cssClass="search-table"
            />
        )
    }

    renderStatus = (status, i) => {
        const { surveyStore } = this

        return (
            <Checkbox
                key={`maxbi_status_${status}`}
                onBlur={surveyStore.toggleMaxbiStatus}
                defaultChecked={surveyStore.maxbiStatuses[status]}
                name={status}
                className="exploriNativeCheckbox"
            >
                <label
                    htmlFor={status}
                    style={{
                        marginBottom: '0px',
                        marginLeft: '10px',
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                >
                    {i18n.t(`maxbiSearch.status_${i + 1}`)}
                </label>
            </Checkbox>
        )
    }

    renderButtons = () => (
        <LinkButton
            href="/survey/0/CE?surveytype=EM"
            label={i18n.t('maxbiSearch.button.newMaxbiEntry')}
            cssClass="button primary regular"
            icon="fa-light fa-circle-plus"
        />
    )

    renderFilterOptions = () => {
        const { surveyStore } = this
        const statuses = [
            'completed',
            'inprogress',
            'incomplete',
            'archived',
        ]

        return (
            <Fragment>
                <br />

                <fieldset className="filter">
                    <Select
                        label={i18n.t('event')}
                        options={surveyStore.products}
                        onBlur={surveyStore.changeProduct}
                        defaultValue={surveyStore.product}
                    />
                </fieldset>

                <br />

                <fieldset className="filter">
                    <Select
                        label={i18n.t('year')}
                        options={surveyStore.years}
                        onBlur={surveyStore.changeYear}
                        defaultValue={surveyStore.year}
                    />
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {i18n.t('status')}
                        :
                    </legend>
                    {statuses.map(this.renderStatus)}
                </fieldset>
            </Fragment>
        )
    }

    render() {
        return (
            <SearchLayout
                pageTitle="Maxbi Entries"
                renderFilterOptions={this.renderFilterOptions}
                renderButtons={this.renderButtons}
                renderTablePanel={this.renderTablePanel}
                renderGuide={this.renderGuide}
                searchStore={this.surveyStore}
                hideFilterAccordion
            />
        )
    }
}

export default MaxbiSearch
